<template>
  <v-row justify="center" class="linktree ml-1 mr-1">
    <v-col sm="12" md="12" lg="6">
      <h2 class="text-sm-body-2">{{ $t("service.supplier.welcome_supplier_label", { name: instance.name }) }}</h2>
      <h3 class="text-sm-body-2">
        <span>{{ $t("service.select_popup.on_table_title", { category: instance.category_establishment }) }}</span>
        <br />
        <span v-html="$t('service.supplier.what_city_label')" />
      </h3>
      <v-btn v-for="item in ciudades" :key="item.slug"
        class="mt-2" block large
        @click="setCiudad(item)"
        v-html="item.label"
        :data-testid="`CityBranch-` + item.label"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "citysBranch",
  props: {
    instance: Object,
    ciudades: Array,
    service: String
  },
  methods: {
    setCiudad(item) {
      this.$emit("setCiudad", item);
    }
  }
};
</script>
